export const MAIN_CLASS_NAME = 'project-sources-tab';
export const EMPTY_CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__empty-content`;
export const EMPTY_CONTENT_PLACEHOLDER_CLASS_NAME = `${EMPTY_CONTENT_CLASS_NAME}__placeholder`;
export const SKELETON_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__skeleton-container`;

export const NO_PROVIDERS_MODAL_CLASS_NAME = `${MAIN_CLASS_NAME}__no-providers-modal`;
export const NO_PROVIDERS_MODAL_CONTENT_CLASS_NAME = `${NO_PROVIDERS_MODAL_CLASS_NAME}__content`;

export const NO_MODELS_MODAL_CLASS_NAME = `${MAIN_CLASS_NAME}__no-models-modal`;
export const NO_MODELS_MODAL_CONTENT_CLASS_NAME = `${NO_MODELS_MODAL_CLASS_NAME}__content`;
export const FIELD_CLASS_NAME = `${NO_MODELS_MODAL_CONTENT_CLASS_NAME}__field`;

export const NO_MODELS_MODAL_WIDTH = 600;

export const SKELETON_HEIGHT = 32;
export const SKELETON_WIDTH = 384;

export const REFRESH_INTERVAL = 5000; // 5 seconds.
